export default __webpack_public_path__ + "static/media/bg5.6bb82aa9.jpg";